import React, { useEffect, useState } from "react";
import { IoPersonCircleOutline as AuthorIcon } from "react-icons/io5";
import ReactMarkdown from "react-markdown";
import { Loader, Error } from "../../components";
import "github-markdown-css/github-markdown-light.css";
import styles from "../about/About.module.css";

const parseFrontmatter = (mdText) => {
  const match = mdText.match(/^---\n([\s\S]*?)\n---/);
  if (!match) return { data: {}, body: mdText };

  const body = mdText.slice(match[0].length).trim();
  const data = {};
  match[1].split("\n").forEach((line) => {
    const colonIdx = line.indexOf(":");
    if (colonIdx === -1) return;
    const key = line.slice(0, colonIdx).trim();
    const val = line.slice(colonIdx + 1).trim().replace(/^["']|["']$/g, "");
    data[key] = val;
  });

  return { data, body };
};

export const StaticPage = ({ slug }) => {
  const [article, setArticle] = useState(null);
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchPage = async () => {
      setLoading(true);
      try {
        const res = await fetch(`/content/${slug}.md`);
        if (!res.ok) throw new window.Error("Page not found.");
        const mdText = await res.text();
        const { data, body: mdBody } = parseFrontmatter(mdText);
        setArticle(data);
        setBody(mdBody);
        setError("");
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [slug]);

  if (loading) return <Loader />;
  if (error) return <Error errorMessage={error} />;

  return (
    <div className={styles.about_page}>
      <article>
        <h1 className={styles.title}>{article.title}</h1>
        <p className={styles.abstract}>{article.abstract}</p>
        {article.author && (
          <div className={styles.meta}>
            <span className={styles.author}>
              <AuthorIcon className={styles.author_icon} />
              {article.author}
            </span>
          </div>
        )}
        <hr className={styles.divider} />
        <div className={`${styles.body} markdown-body`}>
          <ReactMarkdown>{body}</ReactMarkdown>
        </div>
      </article>
    </div>
  );
};
